import { Analytics } from "@vercel/analytics/react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useRecoilState, useSetRecoilState } from "recoil";
import "./App.css";
import Scrollbar from "./components/atoms/scrollbar/scrollbar";
import ExternalBrowserAlert from "./components/ExternalBrowserAlert";
import Footer from "./components/templates/footer";
import Header from "./components/templates/header/header";
import ScrollTop from "./components/templates/scrollTop";
import { menus } from "./constant/menu";
import useDisplay from "./hooks/useDisplay";
import { usePageViewTracking } from "./hooks/usePageViewTracking";
import { route } from "./pages/(v0)/route";
import Router from "./pages/(v1)/router.v1";
import { langState } from "./store/langState";
import { menuState } from "./store/menuState";
import "./styles/animation.css";
import CustomCursor from "./styles/cursor/CustomCursorSam";
import GlobalStyle from "./styles/GlobalStyle";
import ScrollToTop from "./utils/scrollToTop";

function App() {
  const { isDesktop } = useDisplay();
  const [language] = useRecoilState(langState);
  const setMenuAtom = useSetRecoilState(menuState);
  const location = useLocation();

  usePageViewTracking();

  const isDefaultCursorPage = [
    route.electronicAnnounce,
    route.videoGallery,
    route.managementInfoDetail,
  ].some((path) => location.pathname.startsWith(path));

  useEffect(() => {
    const getProductFunc = async () => {
      try {
        setMenuAtom(menus);
      } catch (error) {
        console.log(error);
      }
    };
    getProductFunc();
  }, [language, setMenuAtom]);

  useEffect(() => {
    if (isDesktop && !isDefaultCursorPage) {
      document.body.style.cursor = "none";
    } else {
      document.body.style.cursor = "auto";
    }
  }, [isDesktop, isDefaultCursorPage]);

  return (
    <>
      <Analytics />
      <GlobalStyle isDefaultCursorPage={isDefaultCursorPage} />
      <Scrollbar>
        <ScrollToTop />
        {isDesktop && !isDefaultCursorPage && (
          <CustomCursor isDefaultCursorPage={isDefaultCursorPage} />
        )}
        <ExternalBrowserAlert />
        <Header />
        <Router />
        <ScrollTop />
        <Footer />
      </Scrollbar>
      <ToastContainer
        className="toast"
        position="top-center"
        autoClose={2000}
        hideProgressBar={true}
      />
    </>
  );
}

export default App;
